import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Sidebar } from '@pocketlaw/tetris';
import { useDocumentMetadata } from './DocumentMetadataProvider';
import { MetadataField } from './MetadataField';
export function MetadataList() {
    const { data, activeEntries, documentId } = useDocumentMetadata();
    const customProperties = data.properties.filter(({ property }) => activeEntries.includes(property.name) && property.companyId);
    const commonProperties = data.properties.filter(({ property }) => activeEntries.includes(property.name) && !property.companyId);
    return (<Fragment>
      {Boolean(customProperties.length) && (<Sidebar.Section id="custom-metadata" title={t({ message: 'Custom metadata', comment: 'Metadata section title' })}>
          <Sidebar.DefinitionList>
            {customProperties.map(({ property, pair }) => (<MetadataField key={property.id} documentId={documentId} property={property} pair={pair}/>))}
          </Sidebar.DefinitionList>
        </Sidebar.Section>)}
      {Boolean(commonProperties.length) && (<Sidebar.Section id="common-metadata" title={t({ message: 'Standard metadata', comment: 'Metadata section title' })}>
          <Sidebar.DefinitionList>
            {commonProperties.map(({ property, pair }) => (<MetadataField key={property.id} documentId={documentId} property={property} pair={pair}/>))}
          </Sidebar.DefinitionList>
        </Sidebar.Section>)}
    </Fragment>);
}
